module.exports = __webpack_public_path__ + "static/media/doc.0e9df08d.svg";